// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { accountCenterFieldControlGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    enabled: z.boolean().optional(),
    fields: accountCenterFieldControlGuard.optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    enabled: z.boolean(),
    fields: accountCenterFieldControlGuard,
});
export const AccountCenters = Object.freeze({
    table: 'account_centers',
    tableSingular: 'account_center',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        enabled: 'enabled',
        fields: 'fields',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'enabled',
        'fields',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
